import { Item } from "flows/Picking/models/item/types";

import { ItemPickingState, PickingContext } from "./pickingTypes";
import {
  getActiveItemFromContext,
  getItemsIdsSortedByShelfList,
  getItemWithPickingState,
} from "./pickingUtils";

export const selectOrderDetailsFromContext = (context: PickingContext) => {
  const getPickedQuantity = (itemId: string) => {
    const skippedItemPickingState = getItemWithPickingState(itemId, context, true);
    if (skippedItemPickingState) {
      return skippedItemPickingState.pickedQuantity;
    }
    return getItemWithPickingState(itemId, context, false)?.pickedQuantity || 0;
  };

  // Cast to access order properties that exist on the full Order type
  const order = context.order as Record<string, unknown> | null;

  return {
    orderNumber: order?.number as string | undefined,
    itemsPickedCount: Object.keys(context.itemsMap).reduce((acc, curr) => {
      return acc + getPickedQuantity(curr);
    }, 0),
    numberOfItems: (order?.numberOfItems as number) || 0,
    orderWeight: order?.weight as number | undefined,
    externalDeliveryProvider: order?.externalDeliveryProvider as string | undefined,
    reseller: context.order?.reseller,
  };
};

export const selectItemsSortedByShelf = (context: PickingContext) => {
  let isPickingDone = true;
  let isGiftPicked = true;
  let isCampaignPicked = true;
  let hasFlyersRemoved = true;

  const getItemsWithPickingStateSortedByShelf = (isSkippedItemsList: boolean) => {
    const itemsIdsSortedByShelfList = getItemsIdsSortedByShelfList(context, isSkippedItemsList);
    return itemsIdsSortedByShelfList.flatMap((itemId) => {
      const itemWithPickingState = getItemWithPickingState(itemId, context, isSkippedItemsList);
      if (itemWithPickingState?.state !== "DONE") {
        isPickingDone = false;
      }
      return itemWithPickingState ? [itemWithPickingState] : [];
    });
  };

  if (context.totalGiftsQuantity > context.pickedGiftsQuantity) {
    isGiftPicked = false;
  }
  if (context.totalCampaignsQuantity > context.pickedCampaignsQuantity) {
    isCampaignPicked = false;
  }
  if (context.totalRemoveFlyersQuantity > context.pickedRemoveFlyersQuantity) {
    hasFlyersRemoved = false;
  }

  return {
    itemsSortedByShelf: getItemsWithPickingStateSortedByShelf(false),
    skippedItemsSortedByShelf: getItemsWithPickingStateSortedByShelf(true),
    isPickingDone,
    isGiftPicked,
    isCampaignPicked,
    hasFlyersRemoved,
  };
};

export type CurrentItemToPick = {
  item: Item;
  isSkipped: boolean;
} & ItemPickingState;

export const selectCurrentItem = (context: PickingContext): CurrentItemToPick | undefined => {
  return getActiveItemFromContext(context, false) ?? getActiveItemFromContext(context, true);
};
